import React, { FC } from 'react';
import dynamic from 'next/dynamic';

import { OneClickJoinContainerProps } from './OneClickJoinContainer.types';
import { StyledOneClickJoinContainer } from './OneClickJoinContainer.styles';
import { EditableComponent } from '@adobe/aem-react-editable-components';
const OneClickJoinForm = dynamic(() =>
  import('../../molecules/OneClickJoinForm').then(module => module.OneClickJoinForm)
);

// Use named rather than default exports.
export const OneClickJoinContainer: FC<OneClickJoinContainerProps> = ({ model, isDTT, isAuthorMode }) => {
  return (
    <StyledOneClickJoinContainer
      data-testid="oneclickjoinreservation"
      data-component-name="o-account-oneclickjoinreservation"
    >
      <OneClickJoinForm authorModelData={model} isDTT={isDTT} isAuthorMode={isAuthorMode} />
    </StyledOneClickJoinContainer>
  );
};

export const OneClickJoinContainerConfig = {
  emptyLabel: 'OneClickJoinContainer',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/oneclickjoincontainer`,
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OneClickJoinContainerEditable = (props: any) => {
  return (
    <EditableComponent config={OneClickJoinContainerConfig} {...props}>
      <OneClickJoinContainer {...props} />
    </EditableComponent>
  );
};
